import React, { useEffect, useState } from "react";
import { useSnackbar } from "@components";
import { Modal, Tooltip, Button } from "antd";
import { workflowContainerCheckPointById } from "../../../../../src/libs/apis";
import { WorkflowContainerCheckPointI } from "../../../../../src/libs/interfaces";
import { Box } from "@mui/material";
import type { Dayjs } from "dayjs";
import { FundViewOutlined } from "@ant-design/icons";
import { OneCard } from "../../../../../src/libs/shared";

const noShow = [
  "id",
  "client",
  "producer",
  "farm",
  "zone",
  "balerCode",
  "box",
  "brand",
  "container",
  "clientId",
  "producerId",
  "farmId",
  "magap",
  "boxId",
  "brandId",
  "siglasPhoto",
  "observation",
  "timeStampSave"
];

interface OnePhotoI {
  src: string | number | boolean | Dayjs | null | undefined;
  alt: string;
  showAlt?: boolean;
}

interface OneCardI {
  title: string;
  photos: OnePhotoI[];
  value?: string;
  noLine?: boolean;
}

const titles = {
  //verificadora
  adhesivoPhoto: "Etiqueta Puerta Verificadora",
  cableVerificadoraPhoto: "Sello Cable Verificadora",
  botellaVerificadoraRastreoPhoto: "Sello Botella Verificadora",
  numRastreoSatelitalPhoto: "Número de Rastreo",
  // exportadora
  adhesivoPuertaPhoto: "Etiqueta Puerta Exportador",
  adhesivoBisagraPhoto: "Etiqueta Bisagra Exportador",
  cableExporPhoto: "Sello Cable Exportador",
  botellaExporPhoto: "Sello Botella Exportador",

  //naviera
  botellaNavieraPhoto: "Sello Botella Naviera",
  inspectionContainerPhoto: "Inspección Contenedor",
  ventoleraIzquierdaPhoto: "Foto de Ventolera Izquierda",
  ventoleraDerechaPhoto: "Foto de Ventolera Derecha",
  panelIzquierdoPhoto: "Foto de Panel Izquierdo",
  panelDerechoPhoto: "Foto de Panel Derecho",
  adhesivoBisagraPhoto1: "Etiqueta Bisagra",
  adhesivoBisagraPhoto2: "Etiqueta Bisagra",
  adhesivoBisagraPhoto3: "Etiqueta Bisagra",
  panelExteriorRePhoto1: "Panel Exterior Re-Inspección",
  panelExteriorRePhoto2: "Panel Exterior Re-Inspección",
  panelExteriorRePhoto3: "Panel Exterior Re-Inspección",
} as any;

interface ShowContainerPropsI {
  id: number;
}

export const ShowContainer = ({ id }: ShowContainerPropsI) => {
  const [open, setOpen] = React.useState(false);
  const [showContainer, setShowContainer] = React.useState(false);

  React.useEffect(() => {
    if (showContainer) {
      setOpen(true);
    }
  }, [showContainer]);

  const handleClose = () => {
    setShowContainer(false);
    setOpen(false);
  };

  return (
    <>
      <Tooltip arrow={false} title="Show">
        <Button
          size="small"
          type="dashed"
          onClick={() => setShowContainer(true)}
          icon={<FundViewOutlined />}
        />
      </Tooltip>
      {showContainer && (
        <ModalContainer open={open} onClose={handleClose} id={id} />
      )}
    </>
  );
};

interface ModalContainerPropsI {
  open: boolean;
  onClose: () => void;
  id: number;
}

export const ModalContainer = ({ open, onClose, id }: ModalContainerPropsI) => {
  const [isLoading, setLoading] = useState(true);
  const { enqueueSnackbar } = useSnackbar();
  const [data, setData] = useState<WorkflowContainerCheckPointI>({
    container: "",
  } as WorkflowContainerCheckPointI);
  const [cards, setCards] = useState<OneCardI[]>([]);
  const [lasFotos, setLasFotos] = useState<string[]>([]);

  useEffect(() => {
    handleGetData();
    return () => {
      setLoading(true);
      setData({
        container: "",
      } as WorkflowContainerCheckPointI);
      setCards([]);
    };
  }, []);

  const handleGetData = async () => {
    try {
      const { data: dataContainer } = await workflowContainerCheckPointById(id);
      if (!dataContainer) return;
      setData(dataContainer);
      console.log(dataContainer);
      const arrKeys = Object.keys(dataContainer).filter(
        (el) => !noShow.includes(el)
      ) as Array<keyof WorkflowContainerCheckPointI>;

      const keysParents = arrKeys.filter(
        (el) => !el.includes("panelExteriorPhoto")
      );

      const arrPhotosTotal: string[] = [];
      const arrCards = [];
      for (const x of keysParents) {
        const obj: OneCardI = { title: titles[x] ?? x } as OneCardI;
        const arrPhotos = [];
        for (const y of arrKeys) {
          if (y.includes(x)) {
            arrPhotos.push({
              src: dataContainer[y] as any,
              alt: y,
            });
            arrPhotosTotal.push(dataContainer[y] as any);
          }
        }
        obj.photos = arrPhotos;
        // obj.value = dataContainer[x] as string;
        arrCards.push(obj);
      }
      const objContainer = {
        title: "Contenedor",
        photos: [{ src: dataContainer["siglasPhoto"], alt: "Contenedor" }],
      } as OneCardI;

      arrCards.unshift(objContainer);

   
      console.log(arrCards);
      setCards(arrCards);
      console.log(arrPhotosTotal);
      setLasFotos(arrPhotosTotal);
      setLoading(false);
    } catch (err: any) {
      enqueueSnackbar(err.toString(), { variant: "error" });
      setLoading(false);
    }
  };

  return (
    <Modal
      title={
        <p
          style={{ color: "green" }}
        >{`FOTOS DEL CHECKPOINT CONTENEDOR N°${data.container}`}</p>
      }
      footer={null}
      loading={isLoading}
      open={open}
      onClose={onClose}
      onCancel={onClose}
      width={810}
      centered={true}
      zIndex={1602}
      destroyOnClose={true}
      style={{ padding: 0 }}
    >
      <Box
        sx={{
          display: "grid",
          gap: 2,
          gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
          width: "100%",
          minHeight: 550,
          maxHeight: 550,
          height: 550,
          p: 1,
          overflowY: "auto",
        }}
      >
        {cards.map((el) => (
          <OneCard data={el} key={`${el.title}-card`} lasFotos={lasFotos} />
        ))}
      </Box>
    </Modal>
  );
};
